<template>
    <div class="table-responsive">
        <table class="table table-hover">
            <thead>
            <tr>
                <th>{{ $t('common.time.date') }}</th>
                <th>{{ $t('common.time.hour') }}</th>
                <th>{{ $t('common.service') }}</th>
                <th>{{ $t('common.state') }}</th>
            </tr>
            </thead>
            <tbody>
            <AppointmentRow
                :appointment="appointment"
                v-for="appointment in appointments"
                v-bind:key="appointment.id"
                :selected-client-id="selectedClientId"
            ></AppointmentRow>
            </tbody>
        </table>
    </div>
</template>

<script>
import AppointmentRow from "@/components/appointment/AppointmentRow";

export default {
    name: "AppointmentsTable",
    components: {AppointmentRow},
    props: {
        appointments: {
            type: Array,
            required: true
        },
        selectedClientId: {
            type: Number,
            default: null
        }
    }
}
</script>

<style scoped>

</style>